<template>
  <div id="appointment-details">
    <div class="text-center mr-5 pr-5 ml-5 d-none d-print-block">
      <v-layout row wrap>
        <v-flex sm7 class="text-right pl-5">
          <h3>{{ printTitle }}</h3>
        </v-flex>
        <v-flex sm5 class="text-right">
          <img alt="Bar code" id="barcode" />
        </v-flex>
      </v-layout>
    </div>
    <v-card>
      <v-card-title class="page-heading">Appointment Details</v-card-title>
      <v-card-text class="text-body-1">
        <v-row>
          <v-col><span class="font-weight-black">First Name: </span>{{ firstName }}</v-col>
          <v-col><span class="font-weight-black">Last Name: </span>{{ lastName }}</v-col>
        </v-row>
        <v-row>
          <v-col
            ><span class="font-weight-black">Appointment Date/Time:
              </span>{{ formattedCheckinDateTime }}</v-col
          >
          <v-col v-if="existingAppointment && !newAppointmentSelected">
            <span class="font-weight-black">Service Type: </span>{{ serviceTypeText }}
          </v-col>
          <v-col v-else>
            <span class="font-weight-black">Service Type: </span>{{ testTypeText }}
          </v-col>
        </v-row>
        <v-row>
          <v-col><span class="font-weight-black">Confirmation Number:
            </span>{{ confirmationNumber }}</v-col>
          <v-col><span class="font-weight-black">Email: </span>{{ email }}</v-col>
        </v-row>
        <v-row>
          <v-col><span class="font-weight-black">Phone: </span>{{ phone }}</v-col>
        </v-row>
        <v-row>
          <v-col
            ><span class="font-weight-black">DL Location: </span>
            {{ siteName }}
            <div>{{ siteAddress }}</div>
          </v-col>
        </v-row>
        <div class="font-weight-black mt-6" style="font-size:14px">
          In order to complete your transaction in office, you are required to provide the following
          documents:
        </div>
        <ul style="font-size:14px">
          <li>Proof of Identification - A full list of acceptable documents can be found here.</li>
          <li>Proof of Citizenship - A full list of acceptable documents can be found here.</li>
          <li>
            Proof of Social Security Number - A full list of acceptable documents can be found here.
          </li>
          <li>
            Proof of South Carolina Residency - A full list of acceptable documents can be found
            here.
          </li>
        </ul>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import jsbarcode from 'jsbarcode';
import Print from '../Utilities/Print';

export default {
  props: {
    printTitle: { required: false },
  },
  computed: {
    ...mapGetters(
      'userInfo',
      ['firstName', 'lastName', 'testTypeText', 'phone', 'email'],
    ),
    ...mapGetters(
      'bookingDetails',
      [
        'siteName',
        'siteAddress',
        'confirmationNumber',
        'formattedCheckinDateTime',
        'serviceTypeText',
        'newAppointmentSelected',
      ],
    ),
    ...mapGetters(['existingAppointment']),
  },
  mounted() {
    // finished rendering to the DOM
    if (this.confirmationNumber) {
      // eslint-disable-next-line
      jsbarcode("#barcode", this.confirmationNumber, {
        format: 'code39',
        lineColor: '#000000',
        background: '#FFFFFF',
        width: 1.25,
        height: 35,
        displayValue: false,
      });
    }
  },
  methods: {
    Printer() {
      console.log('Inside Printer of BookingDetailsPanel');
      Print.Print('appointment-details');
    },
  },
};
</script>

<style></style>
